<template>
	<div>
		<div
			v-if="label"
			class="flex flex-wrap items-start justify-between mb-2"
		>
			<div class="flex items-center">
				<label :for="`textarea-${nameToId}`" class="mb-0">
					{{ label }}
				</label>
				<span
					v-if="required"
					class="ml-1 text-lg font-bold leading-none text-red-400"
				>
					*
				</span>
			</div>
			<slot name="label-action" />
		</div>

		<textarea
			ref="textarea"
			:name="name"
			class="w-full px-3 py-2.5 transition-all duration-200 border rounded-lg outline-none resize-y ring-2 focus:ring-neutral-200 ring-transparent placeholder:text-neutral-400 focus:border-neutral-500 border-neutral-200"
			:class="{
				'border-red-400': errorMessage,
				'bg-neutral-50': disabled,
				'font-mono': monospace
			}"
			:id="`textarea-${nameToId}`"
			:tabindex="tabindexAttr"
			:placeholder="placeholder"
			:value="value"
			:rows="rows"
			:autocomplete="
				autocomplete
					? typeof autocomplete === 'boolean'
						? 'on'
						: autocomplete
					: 'off'
			"
			:autofocus="autofocus"
			:required="required"
			:disabled="disabled"
			@input="$emit('input', $event.target.value)"
			@focus="$emit('focus', $event)"
			@blur="$emit('blur', $event.target.value)"
			@keypress="$emit('keypress', $event)"
		/>

		<div v-if="errorMessage" class="mt-1.5 text-sm text-red-500">
			{{ errorMessage }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'BaseTextarea',
	props: {
		label: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: null
		},
		placeholder: {
			type: [String, Number],
			default: null
		},
		value: {
			default: null
		},
		rows: {
			type: Number,
			default: 5
		},
		tabindex: {
			type: [Number, String],
			default: null
		},
		autocomplete: {
			type: [Boolean, String],
			default: false
		},
		autofocus: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		validationMessage: {
			type: String,
			default: null
		},
		error: {
			type: String,
			default: null
		},
		monospace: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		nameToId() {
			return this.name ? this.name.toLowerCase() : ''
		},
		errorMessage() {
			return this.error || this.validationMessage
		},
		tabindexAttr() {
			if (
				this.tabindex === null ||
				typeof this.tabindex === 'undefined'
			) {
				return null
			}

			return String(this.tabindex)
		}
	},
	methods: {
		focus() {
			this.$refs.textarea?.focus()
		}
	}
}
</script>
